import React from "react";
import { Stack, Typography } from "@mui/material";

const TotalComparison = ({censoTotal, userCenso}) => {
	const percent = ((100 / censoTotal) * userCenso).toFixed(1)
  return (
    <Stack
      sx={{ p: "10px", width: "100%", height: "100%" }}
      flexDirection={"column"}
      justifyContent={"space-between"}
      alignItems={"flex-start"}
    >
      <Typography sx={{ width: "100%" }} variant="h5" component={"span"}>
        Respecto al total, has censado:
      </Typography>
      <Typography
        sx={{ width: "100%", fontSize: { xs: "50px", md: "80px" } }}
        align="center"
        variant="h1"
        component={"span"}
      >
        {
          (userCenso === 0 && percent < 0) 
          ? ("--")
          : percent
        }%
      </Typography>
      <Stack
        sx={{
          width: "100%",
          borderTop: "1px solid rgba(255, 255, 255, 0.15)",
          pt: "5px",
          minHeight: "50px",
        }}
        flexDirection={"row"}
        justifyContent={"center"}
        alignItems={"center"}
      >
        <Typography
          sx={{
            mr: "10px",
          }}
        >
          Personas censadas en total:
        </Typography>
        <Typography variant="h5" component={"span"}>
		{censoTotal}
        </Typography>
      </Stack>
    </Stack>
  );
};

export default TotalComparison;
